// src/layouts/ProtectedRoute.js
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { getAccountMeCached } from "lib/axios";

export default function ProtectedRoute({ children, allowedRoles }) {
  const [authState, setAuthState] = useState({ loading: true, user: null });
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    getAccountMeCached({ validateStatus: (s) => s < 500 })
      .then((res) => {
        if (!isMounted) return;
        setAuthState({
          loading: false,
          user: res.status === 200 ? res.data : null,
        });
      })
      .catch(() => {
        if (isMounted) setAuthState({ loading: false, user: null });
      });
    return () => {
      isMounted = false;
    };
  }, []);

  if (authState.loading) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const back = encodeURIComponent(location.pathname + location.search || "/portal");

  if (!authState.user) {
    window.location.replace(`/portal/authentication/sign-in?redirect=${back}`);
    return null;
  }

  if (allowedRoles && Array.isArray(allowedRoles) && !allowedRoles.includes(authState.user.role)) {
    window.location.replace(`/portal/authentication/sign-in?redirect=${back}`);
    return null;
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};
ProtectedRoute.defaultProps = { allowedRoles: null };
